import { useEffect } from 'react';

import { createStore, createHook } from '@atlassian/react-sweet-state';

import { initialCachedEndpointState } from '../../services/cached-endpoint/constants.tsx';
import type { State } from '../../services/cached-endpoint/types.tsx';
import { actions } from './actions.tsx';

type Actions = typeof actions;

const store = createStore<State<string>, Actions>({
	name: 'jira-initial-project-template-name',
	initialState: initialCachedEndpointState,
	actions,
});

export const useFetchInitialProjectTemplateNameSweetState = createHook(store);

export const useFetchInitialProjectTemplateName = ({
	shouldFetch,
	projectId,
}: {
	shouldFetch: boolean;
	projectId: number | undefined;
}) => {
	const [{ fetchedOnce, isFetching, data }, { fetchInitialProjectTemplateName }] =
		useFetchInitialProjectTemplateNameSweetState();

	useEffect(() => {
		if (shouldFetch && projectId && !fetchedOnce && !isFetching && data === undefined) {
			fetchInitialProjectTemplateName({
				projectId: `${projectId}`,
			});
		}
	}, [data, fetchInitialProjectTemplateName, fetchedOnce, isFetching, projectId, shouldFetch]);

	if (!shouldFetch) {
		return {
			data,
			isReady: true,
		};
	}
	return {
		data,
		isReady: fetchedOnce && !isFetching,
	};
};
